import React, { Component, PropTypes } from 'react';
import { BlockPicker } from 'react-color';

class MainColorPicker extends Component {
    state = {
        displayColorPicker: false
    };

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker });
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false });
    };

    handleChange = color => {
        this.props.onColorChange({ target: { value: color.hex } });
    };

    render() {
        return (
            <div className={this.props.className}>
                <button
                    disabled={this.props.isDisabled}
                    style={{ backgroundColor: this.props.color }}
                    className="preset-color-picker-button"
                    onClick={this.handleClick}
                />
                {this.state.displayColorPicker ? (
                    <div className="preset-color-picker-popover">
                        <div className="preset-color-picker-cover" onClick={this.handleClose} />{' '}
                        {/* TODO move colors to store*/}
                        <BlockPicker
                            color={this.props.color}
                            onChange={this.handleChange}
                            colors={[
                                '#23826F',
                                '#000000',
                                '#333333',
                                '#3399cc',
                                '#D7D7D7',
                                '#FFFFFF',
                                '#AC0000',
                                '#CD8511',
                                '#709729',
                                '#5C6C80'
                            ]}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
}

MainColorPicker.propTypes = {
    color: PropTypes.string,
    onColorChange: PropTypes.func,
    className: PropTypes.string
};

export default MainColorPicker;



// WEBPACK FOOTER //
// ./src/components/widgets/MainColorPicker.js